/**
 * Reusable Footer Component
 * 
 * Variants:
 * - "default": Full footer with copyright and links (used on most pages)
 * - "minimal": Simple copyright only (used in test interfaces)
 * 
 * Props:
 * - variant: "default" | "minimal" (default: "default")
 * - className: Additional CSS classes
 * - style: Additional inline styles (merged with base styles)
 */

export default function Footer({ variant = 'default', className = '', style = {} }) {
  const baseStyle = {
    background: '#1a2332',
    color: 'white',
    padding: '0.75rem 2rem',
    minHeight: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 'auto',
    ...style
  };

  const linkStyle = {
    fontSize: '0.85rem',
    textDecoration: 'none',
    color: '#f0f0f0',
    transition: 'color 0.2s'
  };

  if (variant === 'minimal') {
    return (
      <footer style={{ ...baseStyle, textAlign: 'center' }} className={className} data-testid="footer-minimal">
        <p style={{ margin: 0, fontSize: '0.85rem' }}>© 2025 Atikin Academy. All rights reserved.</p>
      </footer>
    );
  }

  // Default variant
  return (
    <footer style={baseStyle} className={className} data-testid="footer">
      <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        <p className="regular-text" style={{ margin: 0, fontSize: '0.85rem' }}>© 2025 Atikin Academy. All rights reserved.</p>
        <div style={{ display: 'flex', gap: '1.5rem' }}>
          <a href="/privacy-policy" className="footer-link" style={linkStyle}>Privacy Policy</a>
          <a href="/contact" className="footer-link" style={linkStyle}>Contact Us</a>
        </div>
      </div>
    </footer>
  );
}
